import { render, staticRenderFns } from "./PageEdit.vue?vue&type=template&id=71aaed8d"
import script from "./PageEdit.vue?vue&type=script&lang=js"
export * from "./PageEdit.vue?vue&type=script&lang=js"
import style0 from "./PageEdit.vue?vue&type=style&index=0&id=71aaed8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports